module.exports = __webpack_public_path__ + "img/download-black.3223badf.svg";